import React, { useState, useEffect } from 'react';
import axios from '../../utils/fvAxios';
import MenuItem from '@mui/material/MenuItem';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { TextField, Typography, Button, Divider, Select } from '@mui/material';
import * as Yup from 'yup';
import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import apiinfo from "../../utils/base-uri.json";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getOrgType } from "../../utils/Token";
import { HasPermissions } from "../../utils/Token";
import INFO from "../../utils/Enums.json";
import { getOrgId } from "../../utils/Token";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function Businessinfo() {
    const { t } = useTranslation();


    //     websiteURL: Yup.string()
    //         .required('Website URL is required !')
    //         .matches(/^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/, 'good'),

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        resolver: yupResolver()
    });

    const [error, setError] = useState(null);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);


    const [details, setDetails] = useState({});
    const [typeRegistration, setTypeRegistration] = useState("");
    const [legalname, setLegalname] = useState("");
    const [legalnameErr, setLegalnameErr] = useState("");
    const [taxid, setTaxid] = useState("");
    const [counrtyid, setCounrtyid] = useState("");
    const [stateid, setStateid] = useState("");
    const [city, setCity] = useState("");
    const [cityErr, setCityErr] = useState("");
    const [zip, setZip] = useState("");
    const [zipErr, setZipErr] = useState("");
    const [address1, setAddress1] = useState("");
    const [address1Err, setAddress1Err] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [telePhone, setTelePhone] = useState("");
    const [telePhoneErr, setTelePhoneErr] = useState("");
    const [phone, setPhone] = useState("");

    const [fax, setFax] = useState("");
    const [webUrl, setWebUrl] = useState("");
    const [tax, setTax] = useState('');
    const [telephoneError, setTelephoneError] = useState(null);
    const [phoneErr, setPhoneErr] = useState(null);
    const [TaxError, setTaxError] = useState(null);
    const [taxidErr, setTaxidErr] = useState(null);
    const [trg, setTrg] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        axios.get(apiinfo.myAccounts.getCompanyDetails
        ).then(res => {
            setDetails(res?.data?.data);
            setTypeRegistration(res?.data?.data?.countryType?.toString());
            setLegalname(res?.data?.data?.name);
            setTaxid(res?.data?.data?.taxID);
            setCounrtyid(res?.data?.data?.country);
            setStateid(res?.data?.data?.state);
            setCity(res?.data?.data?.city);
            setZip(res?.data?.data?.zip);
            setAddress1(res?.data?.data?.address1);
            setAddress2(res?.data?.data?.address2);
            setAddress3(res?.data?.data?.address3);
            setTelePhone(res?.data?.data?.phoneNumber);
            setPhone(res?.data?.data?.extNumber);
            setFax(res?.data?.data?.faxNumber);
            setWebUrl(res?.data?.data?.websiteURL);

            axios.get(apiinfo.addressInfo.getStateByRegion + "clientID=" + 0 + "&country=" + res?.data?.data?.country)
                .then((res) => {
                    if (res?.data?.responseCode === 100) {
                        setStates(res?.data?.data)
                    }
                    else {
                        setError(res?.data?.responseMessage);
                    }
                }).catch(err => {
                    console.log(err)
                })
        }).catch(err => {
            console.log(err)
        })

        axios.get(apiinfo.addressInfo.getCountries)
            .then((res) => {
                if (res?.data?.responseCode === 100) {
                    setCountries(res?.data?.data)
                }
                else {
                    setError(res?.data?.responseMessage);
                }
            }).catch(err => {
                console.log(err)
            })



    }, [trg]);

    const getState = (e) => {
        if (e == "") {
            setError("please select country");
            setCounrtyid(e);
        } else {
            setError("");
            setCounrtyid(e);
            axios.get(apiinfo.addressInfo.getStateByRegion + "clientID=" + 0 + "&country=" + e)
                .then((res) => {
                    if (res?.data?.responseCode === 100) {
                        setStates(res?.data?.data)
                    }
                    else {
                        setError(res?.data?.responseMessage);
                    }
                }).catch(err => {
                    console.log(err)
                })
        }
    }
    // useEffect(() => {


    // }, [reset]);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };


    const ChangeRegistration = (e) => {
        setTypeRegistration(e);
    };
    const ChangeLegalname = (e) => {
        if (e == "") {
            setLegalnameErr("Enter Legal Name ");
            setLegalname(e);
        } else {
            setLegalnameErr("");
            setLegalname(e);
        }

    }
    const ChangeTaxid = (e) => {
        if (e == "") {
            setTaxidErr("Enter Tax id");
            setTaxid(e);
        } else {
            setTaxidErr("");
            setTaxid(e);
        }

    }
    const ChangeState = (e) => {
        setStateid(e);
    }
    const ChangeCity = (e) => {
        if (e == "") {
            setCityErr("Enter City ");
            setCity(e);
        } else {
            setCityErr("");
            setCity(e);
        }

    }
    const ChangeAddress1 = (e) => {
        if (e == "") {
            setAddress1Err("Enter Address ");
            setAddress1(e);
        } else {
            setAddress1Err("");
            setAddress1(e);
        }

    }
    const ChangeAddress2 = (e) => {
        setAddress2(e);
    }
    const ChangeAddress3 = (e) => {
        setAddress3(e);
    }
    const ChangeZip = (e) => {
        if (e == "") {
            setZipErr("Enter Zip/Postal Code")
            setZip(e);
        } else if (e != "" && e.length > 10) {
            setZipErr("Check  Zip/Postal Code")
            setZip(e);
        } else {
            setZipErr("")
            setZip(e);
        }

    }
    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        const numericInput = inputValue.replace(/[^0-9]/g, '');
        if (numericInput.length <= 10) {
            if (numericInput === '') {
                // Field is empty, no error
                setTelePhone('');
                setTelephoneError(true);
            } else if (/^\d{10}$/.test(numericInput)) {
                const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                setTelePhone(formattedInput);
                setTelephoneError(false);
            } else {
                setTelePhone(numericInput);
                setTelephoneError(true);
            }
        } else {
            // Limit to 10 digits, no further input allowed
            setTelePhone(numericInput);
            setTelephoneError(true);
        }
    };
    const FaxinputChange = (event) => {
        const inputValue = event.target.value;
        const numericInput = inputValue.replace(/[^0-9]/g, '');
        if (numericInput.length <= 10) {
            if (numericInput === '') {
                // Field is empty, no error
                setFax('');
                setTaxError(false);
            } else if (/^\d{10}$/.test(numericInput)) {
                const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                setFax(formattedInput);
                setTaxError(false);
            } else {
                setFax(numericInput);
                setTaxError(true);
            }
        } else {
            // Limit to 10 digits, no further input allowed
            setFax(numericInput);  //numericInput.slice(0, 9)
            setTaxError(true);
        }
    };


    const [selectedMonth, setSelectedMonth] = useState(""); // Set a default month
    const [selectedDate, setSelectedDate] = useState(""); // Set a default date
    useEffect(() => {
        setSelectedMonth(""); // Set the default selected month to ""
    }, []);
    const generateDays = (month) => {
        switch (month) {
            case 1: // January
            case 3: // March
            case 5: // May
            case 7: // July
            case 8: // August
            case 10: // October
            case 12: // December
                return Array.from({ length: 31 }, (_, i) => (i + 1).toString());
            case 4: // April
            case 6: // June
            case 9: // September
            case 11: // November
                return Array.from({ length: 30 }, (_, i) => (i + 1).toString());
            case 2: // February
                // Assuming a non-leap year
                return Array.from({ length: 28 }, (_, i) => (i + 1).toString());

            default:
                return [];
        }
    };
    const ChangeWebUrl = (e) => {
        setWebUrl(e);
    }
    const onSubmit = () => {
        setIsLoading(true);
        const data = {
            "organizationID": details?.organizationID,
            "name": legalname,
            "address1": address1,
            "address2": address2,
            "address3": address3,
            "city": city,
            "state": stateid,
            "financialMonth": selectedMonth == "" ? details?.financialMonth : selectedMonth,
            "financialDate": selectedDate == "" ? details?.financialDate : selectedDate,
            "countryType": typeRegistration,
            "zip": zip,
            "country": counrtyid,
            "phoneNumber": telePhone,
            "faxNumber": fax,
            "websiteURL": webUrl,
            "federalIDNumber": details?.federalIDNumber,
            "extNumber": phone,
            "taxID": taxid,
            "singleClientCode": details?.singleClientCode,
            "hasFinancialData": details?.hasFinancialData
        }

        if (legalname !== "" && taxid != "" && counrtyid != "" && stateid != "" && city != "" && zip != "" && address1 != "" && telePhone != "" && zipErr == "") {
            axios.post(apiinfo.myAccounts.saveCompanyDetails, data)
                .then(response => {
                    if (response?.data?.responseCode == 100) {
                        toast.success(response?.data?.responseMessage, {
                            position: "top-right",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        setTrg(!trg);
                    }
                    else {
                        toast.error(response?.data?.responseMessage, {
                            position: "top-right",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    }
                }).catch(err => {
                    console.log(err)
                }).finally(() => {
                    setIsLoading(false);
                })
        } else {
            toast.error("Please Enter Mandatory Fields", {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setIsLoading(false);
        }
    };


    return (
        <React.Fragment>

            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ToastContainer />
            <div className='form'>
                <label className='personal-info-heading'><b>{t('Mycompany.businessinformation')}</b></label> {error && <div className="text-center" style={{ color: "red" }}>{error}</div>}
                <div className='personal-info-subheading'>
                    <small>{t('Mycompany.head')}</small>
                </div>
                {/* {process.env.REACT_APP_SECRET_KEY} */}

                <Divider className='mt-3' />
                <div className='row'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.registration')}<small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">

                        <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={typeRegistration || ""}
                                onChange={(e) => ChangeRegistration(e.target.value)}
                            >
                                <FormControlLabel value="0" control={<Radio />} label="U.S" />
                                <FormControlLabel value="1" control={<Radio />} label="International" />
                            </RadioGroup>
                        </FormControl>
                        <p className='text-danger mx-2 mt-1' component={'span'} >
                            {errors.selecttype?.message}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <span className="mt-2 mx-3" style={{ color: "black", fontWeight: 600 }} hidden={getOrgType() != "Vendor" ? true : false}>To change name, send email to info@firstverify.com with W-9.
                    </span>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-2">
                        <span className="input-label-right">{t('Mycompany.legalname')} <small style={{ color: "red" }}>*</small></span>
                        <br />

                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 }, width: "320px"
                            }}
                            required
                            id="name"
                            name="name"
                            placeholder={t('Mycompany.legalname')}
                            size='small'
                            value={legalname || ""}
                            InputProps={{
                                readOnly: getOrgType() != "Vendor" ? false : true,
                            }}
                            onChange={(e) => ChangeLegalname(e.target.value)}
                        // className="form-control text-feild-custom mx-2"
                        />

                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {legalnameErr}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <span className="mt-2 mx-3" style={{ color: "black", fontWeight: 600 }} hidden={getOrgType() != "Vendor" ? true : false}>	To change tax ID, send email to info@firstverify.com with IRS form SS-4.
                    </span>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.taxid')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            id="taxID"
                            name="taxID"
                            placeholder={t('Mycompany.taxid')}
                            size='small'
                            value={taxid || ""}
                            InputProps={{
                                readOnly: getOrgType() != "Vendor" ? false : true,
                            }}
                            onChange={(event) => {
                                const inputValue = event.target.value;
                                const numericInput = inputValue.replace(/[^0-9]/g, '');
                                if (numericInput.length == 9) {
                                    if (numericInput === '') {
                                        // Field is empty, no error
                                        setTaxid('');
                                        setTaxidErr(false);
                                    }
                                    else if (numericInput) {
                                        setTaxid(numericInput);
                                        setTaxidErr(false);
                                    } else {
                                        setTaxid(numericInput);
                                        setTaxidErr(true);
                                    }
                                } else {
                                    // Limit to 10 digits, no further input allowed
                                    // setPhone(numericInput.slice(0, 10));
                                    setTaxid(numericInput);
                                    setTaxidErr(true);
                                }
                            }}
                            error={taxidErr}
                            helperText={taxidErr ? 'Tax Id should be 9 digit number' : ''}
                        //onChange={(e) => ChangeTaxid(e.target.value)}
                        // className="form-control text-feild-custom mx-2"
                        />
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.country')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        {/* <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                            }}
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            size="small"
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => getState(e.target.value)}
                            value={counrtyid || ""}
                            MenuProps={MenuProps}
                        >
                            {countries?.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </Select> */}
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            size='small'
                            placeholder={t('Mycompany.country')}
                            name="country"
                            id="country"
                            value={counrtyid || ""}
                            MenuProps={MenuProps}
                            // className="form-control text-feild-custom mx-2"
                            onChange={(e) => getState(e.target.value)}
                        >
                            {countries?.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </Select>
                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.country?.message}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.state')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}

                            type="state"
                            id='state'
                            size='small'
                            required
                            name="state"
                            MenuProps={MenuProps}
                            value={stateid || ""}
                            onChange={(e) => ChangeState(e.target.value)}
                            placeholder={t('Mycompany.state')}
                        // className="form-control text-feild-custom mx-2"

                        >
                            {states?.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </Select>
                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.state?.message}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.city')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            id="city"
                            name="city"
                            placeholder={t('Mycompany.city')}
                            size='small'
                            value={city || ""}
                            onChange={(e) => ChangeCity(e.target.value)}
                        />
                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {cityErr}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3 ">
                        <span className="input-label-right">{t('Mycompany.zip')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            id="zip"
                            name="zip"
                            placeholder={t('Mycompany.zip')}
                            size='small'
                            value={zip || ""}
                            onChange={(e) => ChangeZip(e.target.value)}
                        />
                        <br />
                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {zipErr}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right"> {t('Mycompany.addressline1')} <small style={{ color: "red" }}>*</small> </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            id="address1"
                            name="address1"
                            placeholder={t('Mycompany.addressline1')}
                            size='small'
                            value={address1 || ""}
                            onChange={(e) => ChangeAddress1(e.target.value)}

                        />
                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {address1Err}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right"> {t('Mycompany.addressline2')} </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            id="address2"
                            name="address2"
                            placeholder={t('Mycompany.addressline2')}
                            size='small'
                            value={address2 || ""}
                            onChange={(e) => ChangeAddress2(e.target.value)}
                        // className="form-control text-feild-custom mx-2"
                        />
                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {""}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.addressline3')} </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            id="address3"
                            name="address3"
                            placeholder={t('Mycompany.addressline3')}
                            size='small'
                            value={address3 || ""}
                            onChange={(e) => ChangeAddress3(e.target.value)}
                        // className="form-control text-feild-custom mx-2"

                        />
                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {""}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' hidden={getOrgType() != "Vendor"} />
                <div className='row mt-2' hidden={getOrgType() != "Vendor"}>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">Fiscal Year-end Month </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <Select
                            value={selectedMonth || ""}
                            onChange={(event) => {
                                setSelectedMonth(event.target.value);
                                setSelectedDate('');
                            }}
                            displayEmpty
                            MenuProps={MenuProps}
                            required
                            variant="outlined"
                            size="small"
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                        >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value={1}>January</MenuItem>
                            <MenuItem value={2}>February</MenuItem>
                            <MenuItem value={3}>March</MenuItem>
                            <MenuItem value={4}>April</MenuItem>
                            <MenuItem value={5}>May</MenuItem>
                            <MenuItem value={6}>June</MenuItem>
                            <MenuItem value={7}>July</MenuItem>
                            <MenuItem value={8}>August</MenuItem>
                            <MenuItem value={9}>September</MenuItem>
                            <MenuItem value={10}>October</MenuItem>
                            <MenuItem value={11}>November</MenuItem>
                            <MenuItem value={12}>December</MenuItem>
                        </Select>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' hidden={getOrgType() != "Vendor"} />
                <div className='row mt-2' hidden={getOrgType() != "Vendor"}>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">Fiscal Year-end Day</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <Select
                            value={selectedDate}
                            onChange={(event) => setSelectedDate(event.target.value)}
                            required
                            variant="outlined"
                            size="small"
                            // className="form-control text-feild-custom mx-2"
                            MenuProps={MenuProps}
                            displayEmpty
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                        >
                            {generateDays(selectedMonth).map((day) => (
                                <MenuItem key={day} value={day}>
                                    {day}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>


                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.telephonenumber')}<small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            value={telePhone || ""}
                            onInput={handleInputChange}
                            size="small"
                            placeholder={t('Mycompany.telephonenumber')}
                            id="outlined-name"
                            variant="outlined"
                            // className="form-control text-feild-custom mx-2"
                            error={telephoneError}
                            helperText={telephoneError ? 'Invalid  format. Use (xxx) xxx-xxxx' : ''}
                        />
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.phonenumberextension')}</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            id="extNumber"
                            name="extNumber"
                            placeholder={t('Mycompany.phonenumberextension')}
                            size='small'
                            value={phone || ""}
                            onChange={(event) => {
                                const inputValue = event.target.value;
                                const numericInput = inputValue.replace(/[^0-9]/g, '');
                                if (numericInput.length <= 10) {
                                    if (numericInput === '') {
                                        // Field is empty, no error
                                        setPhone('');
                                        setPhoneErr(false);
                                    }
                                    else if (numericInput) {
                                        const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                                        setPhone(numericInput);
                                        setPhoneErr(false);
                                    } else {
                                        setPhone(numericInput);
                                        setPhoneErr(true);
                                    }
                                } else {
                                    // Limit to 10 digits, no further input allowed
                                    // setPhone(numericInput.slice(0, 10));
                                    setPhone(numericInput);
                                    setPhoneErr(true);
                                }
                            }}
                            error={phoneErr}
                            helperText={phoneErr ? 'Only numbers 0000000000' : ''}
                        // className="form-control text-feild-custom mx-2"
                        />
                        {/* <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {phoneErr}
                        </Typography> */}
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.faxnumber')} </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            value={fax || ""}
                            onInput={FaxinputChange}
                            size="small"
                            placeholder={t('Mycompany.faxnumber')}
                            id="outlined-name"
                            variant="outlined"
                            // className="form-control text-feild-custom mx-2"
                            error={TaxError}
                            helperText={TaxError ? 'Invalid  format. Use (xxx) xxx-xxxx' : ''}
                        />
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>


                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.websiteurl')} </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            required
                            id="websiteURL"
                            name="websiteURL"
                            placeholder={t('Mycompany.websiteurl')}
                            size='small'
                            value={webUrl || ""}
                            onChange={(e) => ChangeWebUrl(e.target.value)}
                        // className="form-control text-feild-custom mx-2"
                        />
                        <p className='text-danger mx-2 mt-1' component={'span'}>
                            {""}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>


                </div>

                <Divider className='mt-3' hidden={getOrgType() != "Vendor"} />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3" hidden={getOrgType() != "Vendor"}>
                        <span className="input-label-right">Vendor Code</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 mx-2" style={{ fontWeight: 600 }} hidden={getOrgType() != "Vendor"}>
                        {details?.singleClientCode}
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>

                    <div className='row mt-3 mb-3'>
                        <div className='text-right'>
                            {HasPermissions(INFO?.Screens?.MyCompanyDetails, INFO?.ScreenPermissions?.Modify) && <Button
                                variant="contained"
                                color="primary"
                                sx={{ padding: "15px", textTransform: "capitalize" }}
                                onClick={onSubmit}
                                disabled={phoneErr || telephoneError || TaxError || taxidErr}
                            >
                                {t('Mycompany.save')}
                            </Button>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </React.Fragment >
    )
}
